exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comment-popup{position:fixed;left:0;top:0;width:100vw;height:100vh;background-color:rgba(0,0,0,.5);z-index:9999}.comment-popup .comment-container{background-color:#fff;position:absolute;z-index:10000;border-radius:4px;overflow:hidden}.comment-popup .comment-container .cancel-button{position:absolute;z-index:10001;right:3px;top:3px;width:24px;height:24px;background-size:24px 24px;background-repeat:no-repeat;background-image:url(" + require("../../../assets/images/x-icon.svg") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TaskCompletionStepsMobile/CommentPopup/CommentPopup.scss
// module id = 1657
// module chunks = 0